// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/shop/daily_bg_idle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/shop/daily_bg_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/shop/daily_title_bar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/shop/black_info_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@assets/shop/daily_button.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-character-card-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    padding: 18px 12px;
    min-width: 196px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-family: 'Kim';
}

.shop-character-card-container:hover {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.shop-character-card-title {
    padding: 2px 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 100% 100%;
    width: 94%;
}

.shop-character-card-title-name {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
}

.shop-character-card-title-name span {
    max-width: 100px;
    font-size: 14px;
    text-transform: capitalize;
    overflow: hidden;
    /* text-overflow: ellipsis; */
    white-space: nowrap;
}

.shop-character-card-title-name .character-class {
    font-size: 10px;
    color: #ffa600;
    letter-spacing: 0.32px;
}

.shop-character-card-title span {
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
}

.shop-character-card-info-box {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 100% 100%;
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2px;
}

.shop-character-card-info-box .shop-character-card-info-lv {
    font-weight: 400;
    color: #ffa600;
    font-size: 10px;
}

.shop-character-card-info-container {
    display: flex;
    justify-content: center;
    gap: 4px;
}

.shop-character-card-info-box span {
    font-size: 12px;
    color: #FFFFFF;
}

.shop-character-card-info-box img {
    width: 12px;
    height: 12px;
}

.shop-character-card-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    box-sizing: border-box;
    padding: 0 4px;
    width: 100%;
    position: relative;
}

.shop-character-card-content img {
    width: 128px;
    height: 128px;
    border-radius: 12px;
    transform: scale(0.75);
}

.shop-character-card-effect-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 4px;
    width: 100%;
    max-width: 196px;
    padding: 4px 0;
}

.shop-character-card-effect {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
    background-color: #16181c;
    border-radius: 4px;
    overflow: hidden;
    width: 96px;
    height: 26px;
    position: relative;
}

.shop-character-card-effect span {
    font-size: 11px;
}

.shop-character-card-effect-stat {
    position: absolute;
    top: 0;
    left: 0;
    width: 46px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    color: #FFFFFF;
    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.shop-character-card-effect-value {
    padding: 4px 12px;
    line-height: 12px;
    color: #FFFFFF;
}

.shop-card-price {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: 100% 100%;
    padding: 8px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    color: #FFFFFF;
    font-size: 14px;
    width: 100%;
    margin-bottom: 4px;
    font-family: "Kim";
}

.shop-card-price img {
    width: 14px;
    height: 14px;
}

.shop-character-card-class-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 4px 6px;
}

.character-card-portrait {
    width: 68px;
    min-height: 128px;
    background-position: -40px -40px;
    background-repeat: no-repeat;
    animation: animate-sprite 0.7s steps(1) infinite;
    transform: scale(.6);
}

.shop-character-card-slot {
    box-sizing: border-box;
    width: 43px;
    height: 43px;
    background-color: #1c1f25; 
    border-radius: 6px;
    border: 1px solid #274c57;
    padding: 4px; 
    display: flex; 
    justify-content: center; 
    align-items: center;
} 

.shop-character-card-slot:hover {
    cursor: pointer;
    border: 1px solid #71deff;
} 

.shop-character-card-slot > div {
    width: 32px; 
    height: 32px;
} 


.shop-character-card-dialog-position { 
    position: absolute; 
    top: 20px; 
    right: 20px; 
    z-index: 2; 
}
.shop-character-card-dialog-container {
    background-color: #1c1f25;
    border: 1px solid #3c616c;
    border-radius: 4px;
    padding: 6px 12px;
    display: flex;
    flex-direction: column;
    align-items: center; 
    /* justify-content: center; */
    gap: 8px;
    max-width: 128px;
    position: relative;
}

.shop-character-card-dialog-container > img {
    width: 32px;
    height: 32px;
    border: 1px solid #244752;
    padding: 4px;
    border-radius: 4px;
    position: absolute;
    top: -16px;
    background-color: #1c1f25;    
}

.shop-character-card-dialog-wrapper {
    width: 43px;
    height: 43px;
    border: 1px solid #3e5367;
    border-radius: 6px;
    background-color: #1c1f25;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -20px;
    margin-bottom: -20px;
}

.shop-character-card-dialog-container-image {
    width: 32px;
    height: 32px;
    /* padding: 4px; */
    border-radius: 4px;
    position: absolute;
    background-color: #1c1f25;    
    background-repeat: no-repeat;
}

.shop-character-card-dialog-container p {
    font-size: 10px;
    text-align: center;
}

.shop-character-card-dialog-container .shop-character-card-dialog-name {
    margin-top: 24px;
    text-transform: capitalize;
}

.shop-character-card-dialog-container .shop-character-card-dialog-desc {
    color: #71deff;
}

.shop-character-card-dialog-info-container { 
    margin-top: 6px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
}

.shop-character-card-dialog-info {
    flex: 1;
    padding: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    background-color: #303540;
    border-radius: 4px;
}

.shop-character-card-dialog-info img {
    width: 12px;
    height: 16px;
}

.shop-character-card-dialog-info span {
    font-size: 10px;
    color: #ffffff;
}

.shop-character-card-dialog-container .dialog-button-container { 
    margin-top: 8px; 
    margin-bottom: 4px;
    justify-content: center;
} `, "",{"version":3,"sources":["webpack://./src/components/shopCharacterCard/shopCharacterCard.style.css"],"names":[],"mappings":"AAAA;IACI,yDAAuD;IACvD,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yDAAyD;IACzD,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yDAAuD;IACvD,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,iEAAiE;AACrE;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yDAAsD;IACtD,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,4BAA4B;IAC5B,gDAAgD;IAChD,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B","sourcesContent":[".shop-character-card-container {\n    background-image: url('@assets/shop/daily_bg_idle.png');\n    background-size: 100% 100%;\n    padding: 18px 12px;\n    min-width: 196px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    font-family: 'Kim';\n}\n\n.shop-character-card-container:hover {\n    background-image: url('@assets/shop/daily_bg_active.png');\n}\n\n.shop-character-card-title {\n    padding: 2px 6px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-image: url('@assets/shop/daily_title_bar.png');\n    background-size: 100% 100%;\n    width: 94%;\n}\n\n.shop-character-card-title-name {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 2px;\n}\n\n.shop-character-card-title-name span {\n    max-width: 100px;\n    font-size: 14px;\n    text-transform: capitalize;\n    overflow: hidden;\n    /* text-overflow: ellipsis; */\n    white-space: nowrap;\n}\n\n.shop-character-card-title-name .character-class {\n    font-size: 10px;\n    color: #ffa600;\n    letter-spacing: 0.32px;\n}\n\n.shop-character-card-title span {\n    font-size: 14px;\n    font-weight: 600;\n    color: #FFFFFF;\n}\n\n.shop-character-card-info-box {\n    background-image: url('@assets/shop/black_info_bg.png');\n    background-size: 100% 100%;\n    padding: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 2px;\n}\n\n.shop-character-card-info-box .shop-character-card-info-lv {\n    font-weight: 400;\n    color: #ffa600;\n    font-size: 10px;\n}\n\n.shop-character-card-info-container {\n    display: flex;\n    justify-content: center;\n    gap: 4px;\n}\n\n.shop-character-card-info-box span {\n    font-size: 12px;\n    color: #FFFFFF;\n}\n\n.shop-character-card-info-box img {\n    width: 12px;\n    height: 12px;\n}\n\n.shop-character-card-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    box-sizing: border-box;\n    padding: 0 4px;\n    width: 100%;\n    position: relative;\n}\n\n.shop-character-card-content img {\n    width: 128px;\n    height: 128px;\n    border-radius: 12px;\n    transform: scale(0.75);\n}\n\n.shop-character-card-effect-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 4px;\n    width: 100%;\n    max-width: 196px;\n    padding: 4px 0;\n}\n\n.shop-character-card-effect {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 4px;\n    background-color: #16181c;\n    border-radius: 4px;\n    overflow: hidden;\n    width: 96px;\n    height: 26px;\n    position: relative;\n}\n\n.shop-character-card-effect span {\n    font-size: 11px;\n}\n\n.shop-character-card-effect-stat {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 46px;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 600;\n    color: #FFFFFF;\n    text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n.shop-character-card-effect-value {\n    padding: 4px 12px;\n    line-height: 12px;\n    color: #FFFFFF;\n}\n\n.shop-card-price {\n    background-image: url('@assets/shop/daily_button.png');\n    background-size: 100% 100%;\n    padding: 8px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    color: #FFFFFF;\n    font-size: 14px;\n    width: 100%;\n    margin-bottom: 4px;\n    font-family: \"Kim\";\n}\n\n.shop-card-price img {\n    width: 14px;\n    height: 14px;\n}\n\n.shop-character-card-class-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(3, 1fr);\n    gap: 4px 6px;\n}\n\n.character-card-portrait {\n    width: 68px;\n    min-height: 128px;\n    background-position: -40px -40px;\n    background-repeat: no-repeat;\n    animation: animate-sprite 0.7s steps(1) infinite;\n    transform: scale(.6);\n}\n\n.shop-character-card-slot {\n    box-sizing: border-box;\n    width: 43px;\n    height: 43px;\n    background-color: #1c1f25; \n    border-radius: 6px;\n    border: 1px solid #274c57;\n    padding: 4px; \n    display: flex; \n    justify-content: center; \n    align-items: center;\n} \n\n.shop-character-card-slot:hover {\n    cursor: pointer;\n    border: 1px solid #71deff;\n} \n\n.shop-character-card-slot > div {\n    width: 32px; \n    height: 32px;\n} \n\n\n.shop-character-card-dialog-position { \n    position: absolute; \n    top: 20px; \n    right: 20px; \n    z-index: 2; \n}\n.shop-character-card-dialog-container {\n    background-color: #1c1f25;\n    border: 1px solid #3c616c;\n    border-radius: 4px;\n    padding: 6px 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center; \n    /* justify-content: center; */\n    gap: 8px;\n    max-width: 128px;\n    position: relative;\n}\n\n.shop-character-card-dialog-container > img {\n    width: 32px;\n    height: 32px;\n    border: 1px solid #244752;\n    padding: 4px;\n    border-radius: 4px;\n    position: absolute;\n    top: -16px;\n    background-color: #1c1f25;    \n}\n\n.shop-character-card-dialog-wrapper {\n    width: 43px;\n    height: 43px;\n    border: 1px solid #3e5367;\n    border-radius: 6px;\n    background-color: #1c1f25;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: -20px;\n    margin-bottom: -20px;\n}\n\n.shop-character-card-dialog-container-image {\n    width: 32px;\n    height: 32px;\n    /* padding: 4px; */\n    border-radius: 4px;\n    position: absolute;\n    background-color: #1c1f25;    \n    background-repeat: no-repeat;\n}\n\n.shop-character-card-dialog-container p {\n    font-size: 10px;\n    text-align: center;\n}\n\n.shop-character-card-dialog-container .shop-character-card-dialog-name {\n    margin-top: 24px;\n    text-transform: capitalize;\n}\n\n.shop-character-card-dialog-container .shop-character-card-dialog-desc {\n    color: #71deff;\n}\n\n.shop-character-card-dialog-info-container { \n    margin-top: 6px;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 4px;\n}\n\n.shop-character-card-dialog-info {\n    flex: 1;\n    padding: 4px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    background-color: #303540;\n    border-radius: 4px;\n}\n\n.shop-character-card-dialog-info img {\n    width: 12px;\n    height: 16px;\n}\n\n.shop-character-card-dialog-info span {\n    font-size: 10px;\n    color: #ffffff;\n}\n\n.shop-character-card-dialog-container .dialog-button-container { \n    margin-top: 8px; \n    margin-bottom: 4px;\n    justify-content: center;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
